/* Maison Fleur — theme scripts (no dependencies) */
(function () {
  'use strict';

  var MF = window.MF || { routes: { root: '/', cartAdd: '/cart/add', cartChange: '/cart/change', cartUpdate: '/cart/update' }, strings: {} };
  var root = MF.routes.root.replace(/\/$/, '');
  var qs = function (s, el) { return (el || document).querySelector(s); };
  var qsa = function (s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); };

  /* ---------- store helpers ---------- */
  function store(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = qs('[data-toast]');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  /* ---------- drawers ---------- */
  var overlay = qs('[data-overlay]');
  var activeDrawer = null;
  var lastFocus = null;

  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return false;
    if (activeDrawer && activeDrawer !== d) closeDrawer(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    activeDrawer = d;
    document.body.classList.add('has-drawer');
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-visible'); }); }
    qsa('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { d.focus(); }, 50);
    return true;
  }
  function closeDrawer(keepOverlay) {
    if (!activeDrawer) return;
    var id = activeDrawer.id;
    activeDrawer.classList.remove('is-open');
    qsa('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    activeDrawer = null;
    if (!keepOverlay) {
      document.body.classList.remove('has-drawer');
      if (overlay) { overlay.classList.remove('is-visible'); setTimeout(function () { if (!activeDrawer) overlay.hidden = true; }, 300); }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      if (opener.getAttribute('data-drawer-open') === 'CartDrawer' && document.body.classList.contains('template-cart')) return;
      if (openDrawer(opener.getAttribute('data-drawer-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) closeDrawer();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closePopup(); }
    if (e.key === 'Tab' && activeDrawer) {
      var f = qsa('a[href], button:not([disabled]), input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])', activeDrawer).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- header ---------- */
  var header = qs('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  var searchToggle = qs('[data-search-toggle]');
  var searchPanel = qs('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      var open = searchPanel.hidden;
      searchPanel.hidden = !open;
      searchToggle.setAttribute('aria-expanded', String(open));
      if (open) { var i = qs('input[type="search"]', searchPanel); if (i) i.focus(); }
    });
  }

  /* ---------- announcement rotator ---------- */
  qsa('[data-rotator]').forEach(function (r) {
    var items = qsa('.announcement__item', r);
    if (items.length < 2) return;
    var i = 0;
    var interval = parseInt(r.getAttribute('data-interval'), 10) || 5000;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) interval *= 2;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, interval);
  });

  /* ---------- hero video: crossfade loop ---------- */
  qsa('[data-hero-video]').forEach(function (hero) {
    var first = qs('video', hero);
    var btn = qs('[data-hero-toggle]', hero);
    if (!first) return;
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var src = (mobile && first.getAttribute('data-src-mobile')) || first.getAttribute('data-src');
    if (!src) return;
    var XF = 0.8;
    var paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var visible = true;
    var cur = first, nxt = null, fading = false, raf = 0, swapT = 0;
    first.loop = false;
    function makeNext() {
      nxt = first.cloneNode(false);
      nxt.className = 'hero__video';
      nxt.removeAttribute('data-src'); nxt.removeAttribute('data-src-mobile');
      nxt.muted = true; nxt.playsInline = true; nxt.loop = false; nxt.preload = 'auto';
      nxt.src = src;
      first.parentNode.appendChild(nxt);
    }
    first.addEventListener('playing', function onFirst() {
      first.removeEventListener('playing', onFirst);
      hero.classList.add('is-playing'); first.classList.add('is-front');
      if (!nxt) makeNext();
    });
    function tick() {
      raf = 0;
      if (paused || !visible) return;
      var d = cur.duration;
      if (nxt && d && d > XF * 3 && !fading && cur.currentTime >= d - XF) {
        fading = true;
        var a = cur, b = nxt;
        b.currentTime = 0;
        var p = b.play(); if (p && p.catch) p.catch(function () {});
        a.classList.remove('is-front'); a.classList.add('is-back');
        b.classList.add('is-front');
        swapT = setTimeout(function () { a.classList.remove('is-back'); a.pause(); cur = b; nxt = a; fading = false; }, XF * 1000 + 60);
      } else if (!nxt && d && cur.ended) {
        cur.currentTime = 0; cur.play();
      }
      raf = requestAnimationFrame(tick);
    }
    function play() {
      if (!first.getAttribute('src')) first.src = src;
      var p = cur.play(); if (p && p.catch) p.catch(function () {});
      if (fading && nxt) { var q = nxt.play(); if (q && q.catch) q.catch(function () {}); }
      if (!raf) raf = requestAnimationFrame(tick);
    }
    function stop() {
      cur.pause(); if (nxt) nxt.pause();
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
    }
    function sync() {
      hero.classList.toggle('is-paused', paused);
      if (btn) {
        btn.setAttribute('aria-pressed', String(paused));
        btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
      }
    }
    if (!paused) play();
    sync();
    if (btn) btn.addEventListener('click', function () { paused = !paused; if (paused) stop(); else if (visible) play(); sync(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (paused) return;
        if (visible) play(); else stop();
      }).observe(hero);
    }
  });

  /* ---------- hero leaves: pause while off screen ---------- */
  if ('IntersectionObserver' in window) {
    qsa('[data-air]').forEach(function (el) {
      new IntersectionObserver(function (entries) {
        el.classList.toggle('is-paused', !entries[0].isIntersecting);
      }).observe(el);
    });
  }

  /* ---------- cart ---------- */
  function updateCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.setAttribute('data-count', count);
      el.textContent = count > 0 ? count : '';
    });
  }
  function renderDrawer(html) {
    var drawer = qs('[data-cart-drawer]');
    if (!drawer || !html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = qs('[data-cart-drawer]', doc);
    if (fresh) drawer.innerHTML = fresh.innerHTML;
  }
  function refreshCart(sectionsHtml) {
    var p = sectionsHtml && sectionsHtml['cart-drawer']
      ? Promise.resolve(sectionsHtml['cart-drawer'])
      : fetch(root + '/?section_id=cart-drawer').then(function (r) { return r.text(); });
    return p.then(function (html) {
      renderDrawer(html);
      return fetch(root + '/cart.js').then(function (r) { return r.json(); });
    }).then(function (cart) { updateCount(cart.item_count); return cart; });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var buttons = qsa('[data-add-button], button[type="submit"]', form);
    var sticky = qs('[data-sticky-atc] [data-add-button]');
    if (sticky && form.id && sticky.getAttribute('form') === form.id) buttons.push(sticky);
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer');
    fd.append('sections_url', window.location.pathname);
    fetch(MF.routes.cartAdd + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.json.description || res.json.message || MF.strings.error); return; }
        return refreshCart(res.json.sections).then(function () {
          if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
          openDrawer('CartDrawer');
        });
      })
      .catch(function () { toast(MF.strings.error); })
      .finally(function () { buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); }); });
  });

  function changeLine(line, qty) {
    var host = qs('[data-cart-drawer]');
    if (host) host.style.opacity = '.6';
    return fetch(MF.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); })
      .then(function (j) {
        if (j.status && j.description) toast(j.description);
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCart(j.sections);
      })
      .catch(function () { toast(MF.strings.error); })
      .finally(function () { if (host) host.style.opacity = ''; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-change]');
    if (!b) return;
    var item = b.closest('[data-line]');
    if (!item) return;
    changeLine(parseInt(item.getAttribute('data-line'), 10), Math.max(0, parseInt(b.getAttribute('data-qty-change'), 10)));
  });
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('[data-qty-input]');
    if (inp) {
      var item = inp.closest('[data-line]');
      if (item) changeLine(parseInt(item.getAttribute('data-line'), 10), Math.max(0, parseInt(inp.value, 10) || 0));
      return;
    }
    var note = e.target.closest('[data-cart-note]');
    if (note) {
      fetch(MF.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }
  });

  /* ---------- product page ---------- */
  qsa('[data-qty-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      var input = b.parentElement.querySelector('input');
      var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10);
      input.value = Math.max(1, v);
    });
  });

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts[1] === '00' ? withCommas : withCommas + '.' + parts[1];
    return '<span class="money" dir="ltr">ILS ' + amount + '</span>';
  }

  qsa('[data-product-section]').forEach(function (section) {
    var picker = qs('[data-variant-picker]', section);
    var gallery = qs('[data-gallery]', section);
    var dots = qsa('.gallery-dots span', section);

    if (gallery && dots.length) {
      gallery.addEventListener('scroll', function () {
        var items = gallery.children;
        var w = items[0].getBoundingClientRect().width;
        var idx = Math.round(Math.abs(gallery.scrollLeft) / (w + 10));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });
    }

    if (picker) {
      var variants = JSON.parse(qs('[data-variants]', picker).textContent);
      picker.addEventListener('change', function () {
        var selected = qsa('fieldset', picker).map(function (fs) { var c = qs('input:checked', fs); return c ? c.value : null; });
        var v = variants.find(function (variant) { return variant.options.every(function (o, i) { return o === selected[i]; }); });
        var idInputs = qsa('[data-variant-id]');
        var addButtons = qsa('[data-add-button]');
        if (!v) {
          addButtons.forEach(function (b) { b.disabled = true; b.textContent = MF.strings.unavailable; });
          return;
        }
        idInputs.forEach(function (i) { i.value = v.id; });
        addButtons.forEach(function (b) { b.disabled = !v.available; b.textContent = v.available ? MF.strings.addToCart : MF.strings.soldOut; });
        qsa('[data-product-price]').forEach(function (p) {
          var html = '<span class="price" data-price>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html += '<span class="price__sale">' + formatMoney(v.price) + '</span> <s class="price__compare">' + formatMoney(v.compare_at_price) + '</s>';
          } else {
            html += '<span>' + formatMoney(v.price) + '</span>';
          }
          p.innerHTML = html + '</span>';
        });
        if (v.featured_media && gallery) {
          var target = qs('[data-media-id="' + v.featured_media.id + '"]', gallery);
          if (target) {
            if (window.matchMedia('(min-width: 990px)').matches) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            else gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }

    var sticky = qs('[data-sticky-atc]');
    var mainButton = qs('.buy [data-add-button]', section);
    if (sticky && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', out);
        sticky.setAttribute('aria-hidden', String(!out));
        var b = qs('[data-add-button]', sticky);
        if (b) b.tabIndex = out ? 0 : -1;
      }).observe(mainButton);
    }
  });

  /* ---------- recommendations ---------- */
  qsa('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    var load = function () {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = qs('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else load();
  });

  /* ---------- collection: sort & filters ---------- */
  var sort = qs('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- welcome popup ---------- */
  var popup = qs('[data-popup]');
  function closePopup() {
    if (!popup || popup.hidden) return;
    popup.hidden = true;
    var days = parseInt(popup.getAttribute('data-days'), 10) || 21;
    store('mf-popup', String(Date.now() + days * 864e5));
  }
  if (popup) {
    var saved = store('mf-popup');
    var posted = popup.querySelector('.popup__code');
    if (posted) { popup.hidden = false; }
    else if (saved !== 'done' && !(saved && Number(saved) > Date.now())) {
      setTimeout(function () {
        if (activeDrawer) return;
        popup.hidden = false;
        var input = qs('input[type="email"]', popup);
        if (input) input.focus({ preventScroll: true });
      }, parseInt(popup.getAttribute('data-delay'), 10) || 7000);
    }
    qsa('[data-popup-close]', popup).forEach(function (b) { b.addEventListener('click', closePopup); });
  }
})();
